/**
 * Javascript specific to cookie acceptance
 */

window.jhCookie = {
    accepted: function() {
      return this.get('cookies_accepted')
    },
    get: function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },
    set: function(name,value,days,path) {
        if ( name === 'cookies_accepted' || this.get('cookies_accepted') ) {
            var expires = "",
                secure  = '';

            path = path || "/";

            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }

            // check localized.gwp_environment and set the secure variable if this is not LOCAL
            if( 'LOCAL' !== localized.gwp_environment ){
                secure = '; Secure';
            }

            document.cookie = name + "=" + (value || "")  + expires + "; path=" + path + secure;
            return true;
        }
        return false;
    },
    delete: function(name) {
        document.cookie = name+'=; Max-Age=-99999999;';
    }
};

(function (window, document, $) {
    'use strict';

    var $scoped = $('.cookie-acceptance');
    var $oneTrust = $('div#onetrust-banner-sdk');
    
    // For regular GWP cookie 
    if ( $scoped.length > 0 ) {
        $($scoped).find('.cookie-acceptance__accept').click(function() {
            window.jhCookie.set('cookies_accepted', 'true', 360);
            clear_cookie_prompt();
        });
    }
    
    // For oneTrust cookie
    if ( $oneTrust ) {
        $( 'body' ).on( 'click', '#onetrust-accept-btn-handler', function () {  
            window.jhCookie.set('cookies_accepted', 'true', 360);
        });
    }

    function clear_cookie_prompt() {
        $('body').removeClass('cookies-not-accepted');
        $('.cookie-acceptance').fadeOut();
    }

})( window, document, jQuery );
